import type { UnifiedProductSummary } from '../types/UnifiedProductSummary';

const defaults: Readonly<UnifiedProductSummary> = {
  attributes: {
    partnerName: 'Lisa Angel',
    partnerShortcode: 'lisaangeljewellery',
  },
  available: true,
  code: 890605,
  freeDomesticDelivery: true,
  images: [
    {
      altText: 'Engraved leather bracelet in brown',
      height: 1000,
      uri: 'https://cdn.notonthehighstreet.com/fs/75/fc/{size}_leather-bracelet.jpg',
      width: 1000,
    },
  ],
  isNew: false,
  onSale: false,
  preSalePrices: null,
  priceInfo: {
    currencyCode: 'GBP',
    originalPrice: null,
    price: 24.5,
  },
  purchasable: true,
  salePercentage: 0,
  title: 'Engraved Men’s Polished Leather Bracelet In Brown',
  uri: 'https://notonthehighstreet.com/lisaangeljewellery/product/engraved-leather-bracelet',
};

export const buildUnifiedProductSummary = (
  unifiedProductSummary?: Partial<UnifiedProductSummary>,
): Readonly<UnifiedProductSummary> => ({
  ...defaults,
  ...unifiedProductSummary,
});
